import './src/styles/global.css';
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./src/styles/cookie-consent.css";
import React, { cloneElement, createElement } from 'react';
import Root from './src/components/Root';

export const wrapPageElement = ({ element }) => {
  const newElement = cloneElement(
    element,  // I18nextProvider
    element.props,
    cloneElement(
      element.props.children,  // I18nextContext.Provider
      element.props.children.props,
      createElement(
        Root,
        undefined,
        element.props.children.props.children,
      ),
    ),
  );

  return newElement;
};